import { IDocumentTokenDto } from "@/models/document-token.entity";
import { SignatureQRTokenConfig, SignatureImageTokenConfig } from "@/lib/signature-token.utils";
import { VuetifyMaterialColorEnum } from "@/lib/enum/vuetify-color.enum";
import { BaseTokenEntity, ITokenEntity } from "./base-token.entity";
import { IHistory } from "./token-history";

export class SignatureTokenEntity extends BaseTokenEntity {
  static readonly token = "{{sign.qr}}";
  static readonly imageToken = "{{sign.img}}";

  showQr: boolean;

  constructor(
    data: Partial<ITokenEntity> & { x: number; y: number; w?: number; h?: number; showQr?: boolean },
    history?: IHistory
  ) {
    const showQr = data.showQr !== false;
    const defaultSize = showQr ? { w: 0.26, h: 0.12 } : { w: 0.2, h: 0.09 };
    super({ ...data, w: data.w ?? defaultSize.w, h: data.h ?? defaultSize.h }, history);
    this.showQr = showQr;
  }

  get tokenString(): string {
    return this.showQr ? SignatureTokenEntity.token : SignatureTokenEntity.imageToken;
  }

  get colorHex(): string {
    return VuetifyMaterialColorEnum.BLUE_GREY_DARKEN_1;
  }

  get icon(): string {
    return "mdi-draw";
  }

  get color(): string {
    return "blue-grey darken-1";
  }

  get labelKey(): string {
    return "sign.fieldType.signature";
  }

  get defaultSize(): { w: number; h: number } {
    return this.showQr !== false ? { w: 0.26, h: 0.12 } : { w: 0.2, h: 0.09 };
  }

  get fixedSize(): boolean {
    return true;
  }

  validateConstraints(pageWidthMm?: number, pageHeightMm?: number): void {
    const config = this.showQr ? SignatureQRTokenConfig : SignatureImageTokenConfig;
    const width = pageWidthMm ? config.w / pageWidthMm : this.defaultSize.w;
    const height = pageHeightMm ? config.h / pageHeightMm : this.defaultSize.h;
    this.centerBounds(width, height);
  }

  toggleQr(pageWidthMm?: number, pageHeightMm?: number): void {
    this.showQr = !this.showQr;
    this.validateConstraints(pageWidthMm, pageHeightMm);
  }

  toDto(widthPx: number, heightPx: number): IDocumentTokenDto {
    return this.buildDto(widthPx, heightPx);
  }

  clone(history?: IHistory): SignatureTokenEntity {
    const copy = new SignatureTokenEntity(
      {
        ...(this as unknown as Partial<ITokenEntity>),
        x: this.x,
        y: this.y,
        showQr: this.showQr
      },
      history
    );
    copy.id = this.id;
    return copy;
  }
}
